export function getDescription(companyName, locationName, locationId) {
  if (!companyName || !locationName || !locationId) return ''

  let name = `${companyName.replace(/\s+/g, '').substr(0, 10)}${locationName
    .replace(/\s+/g, '')
    .substr(0, 10)}`

  return `name=${name},location_id=${locationId}`
}
